document.addEventListener('DOMContentLoaded', function() {
  
  // Debug: vérifier si les éléments existent
  const faqItems = document.querySelectorAll('.faq-club .bloc3-25108144390523 .faq-item');
  
  // Debug alternatif: essayer de trouver par classe plus simple
  const faqItemsAlt = document.querySelectorAll('.faq-item');
  
  // Utiliser les items trouvés
  const itemsToUse = faqItems.length > 0 ? faqItems : faqItemsAlt;
  
  if (itemsToUse.length === 0) {
    return;
  }
  
  itemsToUse.forEach((item, index) => {
    const question = item.querySelector('.faq-question');
    
    if (question) {
      question.addEventListener('click', function(e) {
        e.preventDefault(); // Empêche le comportement par défaut
        
        const isActive = item.classList.contains('active');
        // Ferme tous les autres items
        itemsToUse.forEach((otherItem, otherIndex) => {
          if (otherItem !== item && otherItem.classList.contains('active')) {
            otherItem.classList.remove('active');
          }
        });
        
        // Toggle l'item actuel
        if (isActive) {
          item.classList.remove('active');
        } else {
          item.classList.add('active');
        }
      });
    }
  });
});